import React from "react";

const Watch = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M18 33.222c-1.844 0-3.67-.365-5.375-1.075a14.04 14.04 0 01-4.556-3.063 14.134 14.134 0 01-3.045-4.583 14.2 14.2 0 010-10.813A14.134 14.134 0 018.07 9.105a14.04 14.04 0 014.556-3.063A13.973 13.973 0 0118 4.967c3.725 0 7.297 1.488 9.931 4.138a14.17 14.17 0 014.114 9.99c0 3.746-1.48 7.34-4.114 9.99A14.003 14.003 0 0118 33.221zm1.56-14.127v-7.85h-3.12v10.989h7.802v-3.14h-4.681zM2 8.549L7.516 3l2.209 2.22-5.52 5.55L2 8.55zM28.482 3L34 8.549l-2.207 2.221-5.518-5.55L28.484 3h-.002z"
            fill={fill}
        />
    </svg>
);

export default Watch;